<template>
    <VForm
        v-slot="{ form }"
        :on-submit-async="submit"
        @success="(value)=>this.$emit('success',value)">
        <BundleCouponCreateAndUpdateFormItems
            :form="form"
            :data="bundleCoupon"
            :is-update-form="true" />
    </VForm>
</template>
<script>
import { rootActions, Getters } from '@/store/types'
import VForm from '@/components/VForm.vue'
import BundleCouponCreateAndUpdateFormItems from '@/components/BundleCouponCreateAndUpdateFormItems.vue'

export default {
    components: {
        VForm,
        BundleCouponCreateAndUpdateFormItems,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    computed: {
        bundleCoupon () {
            return this.$store.getters[Getters.shop.GET_BUNDLE_COUPON](this.id)
        },
    },
    methods: {
        async submit (values) {
            const res = await this.$store.dispatch(
                rootActions.UPDATE_BUNDLE_COUPON, { id: this.id, ...values },
            )
            return res
        },
    },
}
</script>
